module.exports = {
        srcSet: __webpack_public_path__ + "static/media/smartphone_play-500.ead7a31a.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "static/media/smartphone_play-500.ead7a31a.webp",width: 500,height: 500}],
        src: __webpack_public_path__ + "static/media/smartphone_play-500.ead7a31a.webp",
        toString: function(){return __webpack_public_path__ + "static/media/smartphone_play-500.ead7a31a.webp"},
        
        width: 500,
        height: 500
      }